module.exports = __webpack_public_path__ + "img/sld_ch_13_t1_green.40f87c1d.svg";